import { compose } from 'redux'
import { connect } from 'react-redux'
import { withFormik } from 'formik'
import * as yup from 'yup'
import { bindPromiseCreators } from '../../../../../utils/routines'
import {
  createUploadFilesPromise
} from '../../../routines'
import { FILE_SIZE, FILE_TYPE } from '../Forms/validationMessages'

const mapDispatchToProps = bindPromiseCreators({ upload: createUploadFilesPromise })
const connector = connect(null, mapDispatchToProps)

const MAX_SIZE = 50 * 1e6 // 50 mb
const SUPPORTED_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.ms-excel',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
]
const formik = withFormik({
  mapPropsToValues: ({ model, period }) => ({
    files: '',
    model,
    period: period || null
  }),
  validationSchema: props => {
    let files = yup.mixed()
    if (props.mandatory) {
      files = files.required()
    }
    return yup.object().shape({
      files: files
        .test(
          'fileSize',
          FILE_SIZE,
          value => value == null || value.size <= MAX_SIZE
        )
        .test(
          'fileType',
          FILE_TYPE,
          value => value == null || SUPPORTED_TYPES.includes(value.type)
        ),
      model: yup.string().required(),
    })
  },
  async handleSubmit(values, { props, setSubmitting, setStatus, resetForm }) {
    try {
      const data = new FormData()
      Object.entries(values).forEach(([name, value]) => {
        if (value != null) data.append(name, value)
      })
      await props.upload({
        id: props.application.id,
        data
      })
      // for security reasons delete token
      // FIXME: if the component unmounts because is from other period
      // call setState on unmounted component...
      resetForm()
      props.handleParsingError(props.model, 'remove')

      if (props.onUploadSuccess) {
        props.onUploadSuccess(props.model, props.period)
      }

      // manage by redux
      // setStatus({ success: result })
      return
    } catch (error) {
      props.handleParsingError(props.model, 'add')
      setStatus({ error })
    } finally {
      setSubmitting(false)
    }
  }
})

export default compose(
  connector,
  formik
)
